module.exports = __webpack_public_path__ + "img/icon-4.e6af4353.png";